export default {
  title: {
    id: 'mobile_service_redirect_modal_title',
    defaultMessage: 'Redirecting to {mobileService}',
  },
  text1: {
    id: 'mobile_service_redirect_modal_text1',
    defaultMessage:
      'To get help with your mobile plan, we’re sending you to the {mobileService} website.',
  },
  text2: {
    id: 'mobile_service_redirect_modal_text2',
    defaultMessage:
      'If you choose to cancel your mobile plan, it might cancel all other bundled devices and/or services.',
  },
  cta: {
    id: 'mobile_service_redirect_modal_cta',
    defaultMessage: 'Get help on {mobileService}',
  },
  cancellationCta: {
    id: 'mobile_service_redirect_modal_cancellation_cta',
    defaultMessage: 'Cancel mobile plan',
  },
  loading: {
    id: 'mobile_service_redirect_modal_loading',
    defaultMessage: 'Loading redirection links',
  },
  errorTitle: {
    id: 'mobile_service_redirect_modal_error_title',
    defaultMessage: 'Something went wrong',
  },
  errorContent: {
    id: 'mobile_service_redirect_modal_error_content',
    defaultMessage: 'We couldn’t load the redirection links. Please try again.',
  },
  errorRetryCta: {
    id: 'mobile_service_redirect_modal_error_retry_cta',
    defaultMessage: 'Try again',
  },
}
